import script from "./InteractiveHistogram.vue?vue&type=script&setup=true&lang=js"
export * from "./InteractiveHistogram.vue?vue&type=script&setup=true&lang=js"

import "./InteractiveHistogram.vue?vue&type=style&index=0&id=f4549b4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4549b4e"]])

export default __exports__